const selectors = {
  opportunityList: (state) => state.suggestion.opportunityList.data,
  lowPerformanceKeywords: (state) => state.suggestion.lowPerformanceKeywords.data,
};

export default selectors;
